module.exports = __webpack_public_path__ + "media/images/favicons/android-icon-192x192-5a2f6af7a6105331c3a85dff1158fc00.png";